import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getDocumentaleLanguagePath } from "../i18n";
import { env } from "../lib/env";

export function LoginBanner() {
    const { i18n, t } = useTranslation();
    const [loginKey, setLoginKey] = useState("loginExtensiveLabel.desktop")
    const documentaleLang = getDocumentaleLanguagePath(i18n.language);

    useEffect(() => {
        const mediaQuery: MediaQueryList = window.matchMedia("(max-width: 768px)");

        const handleScreenChange = (e: MediaQueryListEvent | MediaQueryList) => {
            if (e.matches) {
                setLoginKey("loginExtensiveLabel.mobile");
            } else {
                setLoginKey("loginExtensiveLabel.desktop");
            }
        };
        mediaQuery.addEventListener("change", handleScreenChange);
        handleScreenChange(mediaQuery);
        return () => {
            mediaQuery.removeEventListener("change", handleScreenChange);
        };
    }, []);

    return (
        <div className="w-full md:w-fit md:text-nowrap top-label flex flex-col md:flex-row gap-3 justify-between md:justify-center rounded-2xl md:items-center px-4 py-2 bg-primary-50 border border-primary-200 text-primary-700">
            <div>
                {t(loginKey)}
            </div>
            <a
                href={`${env.REACT_APP_DOCUMENTALE_URL}/${documentaleLang}`}
                target="_blank"
                rel="noreferrer"
                className="flex justify-center items-center gap-2 px-[12px] py-[4px] rounded-[16px] bg-primary-600 shadow-sm shadow-[rgba(16,24,40,0.05)] no-underline text-white font-semibold">
                {t("loginLabel")}
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.5 9L9.5 3M9.5 3H5.5M9.5 3V7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </a>
        </div >
    )

}
